import {Album} from '@app/web-player/albums/album';
import {Artist} from '@app/web-player/artists/artist';
import {Track} from '@app/web-player/tracks/track';

export const FOCUS_MODEL = 'focus';

export interface Focus {
  id: number;
  model_type: 'focus';
  title: string;
  text?: string;
  cta_label?: string;
  cta_url?: string;
  starts_at?: string | null;
  ends_at?: string | null;
  image_desktop_light?: string;
  image_desktop_dark?: string;
  image_mobile_light?: string;
  image_mobile_dark?: string;
  focusable_type: 'track' | 'album' | 'artist' | 'custom';
  focusable_id?: number | null;
  focusable?: Track | Album | Artist;
  created_at?: string;
  updated_at?: string;
}
